<template>
    <input
        :placeholder="placeholder"
        :type="type"
        :value="value"
        @input="onInput"
        class="adriel-common-input"
        :id="identifier"
        ref="elem"
        :autofocus="autofocus"
    />
</template>

<script>
export default {
    mounted() {
        if (this.autofocus === true) {
            const elem = this.$refs.elem;
            elem && elem.focus();
        }
    },
    props: {
        placeholder: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: 'text',
        },
        value: {
            type: [String, Number],
            default: '',
        },
        autocomplete: {
            type: String,
            default: '',
        },
        autofocus: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
        },
        identifier: String,
    },
    methods: {
        onInput(e) {
            const { value = '' } = e?.target ?? {};
            this.$emit('input', value);
        },
    },
};
</script>

<style lang="scss">
input.adriel-common-input {
    height: 40px;
    box-shadow: none;
    background-color: $color1;
    font-size: 14px;
    font-weight: 500;
    color: #393c3f;
    width: 100%;
    font-family: $font-common;
    padding: calc(0.375em - 1px) 15px;
    border-radius: 3px;
    border: 1px solid $color3;

    &:focus,
    &:active {
        outline-color: #0054c6;
        border-color: #0054c6;
    }

    &:-webkit-autofill {
        background-color: $color1 !important;
        -webkit-box-shadow: 0 0 0px 1000px white inset;
    }

    &::-webkit-input-placeholder {
        color: #bdc2c7;
    }
    &::-moz-placeholder {
        color: #bdc2c7;
    }
    &:-ms-input-placeholder {
        color: #bdc2c7;
    }

    &.disabled {
        color: #666;
        padding: 5px;
        background-color: #f5f5f5;
        border: 1px solid #ccc;
    }
}
</style>
